export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq1_buy.236547e4.mp3";